const getRouletteBgColor = (number: string) => {
	const redNumbersEuropean = [
		'1',
		'3',
		'5',
		'7',
		'9',
		'12',
		'14',
		'16',
		'18',
		'19',
		'21',
		'23',
		'25',
		'27',
		'30',
		'32',
		'34',
		'36'
	];

	if (redNumbersEuropean.includes(number)) return 'rgb(233, 38, 54)';

	return 'transparent';
};

export default getRouletteBgColor;
